import React from "react";
import RecordingsTable from "../../components/RecordingTable/RecordingsTable";

const Recordings = () => {
  return <RecordingsTable />;
};

export default Recordings;
